export * from './angularfire2';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// C:/React/Antique/~/angularfire2/index.js
// module id = ../../../../angularfire2/index.js
// module chunks = 3